const triggerBrowserReflow = node => {
  node.offsetHeight; // eslint-disable-line  no-unused-expressions
};

export default triggerBrowserReflow;
